import { openBlock, createElementBlock } from 'vue';

var LOADED = 'loaded';
var TOKEN = 'token';
var PING = 'ping';
var STYLE = 'style';
var ERROR = 'error';
var AUTO_SUBMIT = 'autoSubmit';
var UPDATE = 'update';
var GET_TOKEN = 'getToken';
var FOCUS = 'focus';
var UPDATE_ISSUER = 'updateIssuer';
var INIT = 'init';
var FORMAT = 'format';
var SET_PLACEHOLDER = 'setPlaceholder';
var CLEAR_DATA = 'clearData';
var CARD_TYPE = 'card';
var CVV_TYPE = 'cvv';
var ACH_TYPE = 'ach';
var SET_ACCOUNT_DATA = 'setAccountData';
var ENABLE_LOGGING = 'enableLogging';
var ENABLE_AUTO_SUBMIT = 'enableAutoSubmit';
var ENABLE3DS = 'enable3DS';
var DISABLE3DS = 'disable3DS';
var AUTO_FORMAT_DEFAULT_SEPARATOR = " ";
var IFIELDS_VERSION = '2.15.2302.0801';
var PLUGIN_NAME = "vue-cardknox-ifields";
var IFIELD_ORIGIN = "https://cdn.cardknox.com";
var THREEDS_ENVIRONMENT = {
  Production: 'production',
  Staging: 'staging'
};

/**
*
* @param {MessageEvent} e
*/
function _onMessage(e) {
    var data = e.data;
    if (!this.iFrameRef) {
        this.log("Unable to handle message: " + data.action);
        return;
    }
    if (e.source !== this.iFrameRef.contentWindow) { return; }
    switch (data.action) {
        case LOADED:
            this.log("Message received: ifield loaded");
            this._onLoad();
            break;
        case TOKEN:
            this.log("Message received: " + TOKEN);
            this._onToken(data);
            break;
        case AUTO_SUBMIT:       //triggered when submit is fired within the iFrame
            this.log("Message received: " + AUTO_SUBMIT);
            this._onSubmit(data);
            break;
        case UPDATE:
            this.log("Message received: " + UPDATE);
            this._onUpdate(data);
            break;
    }
    if (this.threeDS && this.threeDS.enable3DS && data.eci && data.eci.length && this.type === CARD_TYPE) {
        this.log("Message received: eci");
        this.postMessage(data);
    }
}
function _onLoad() {
    this.iFrameLoaded = true;
    var newAccount = this.transformAccountData(this.account);
    this.setAccount(newAccount);
    if (this.type === CARD_TYPE)
        { if (this.threeDS && this.threeDS.enable3DS && !!this.threeDS.environment)
            { this.enable3DS(this.threeDS.environment, this.threeDS.handle3DSResults); }
        else
            { this.disable3DS(); } }
    this.init();
    if (this.type === CVV_TYPE && this.issuer)
        { this.updateIssuer(this.issuer); }
    if (this.options.placeholder)
        { this.setPlaceholder(this.options.placeholder); }
    if (this.options.enableLogging)
        { this.enableLogging(); }
    if (this.type === CARD_TYPE && this.options.autoFormat)
        { this.enableAutoFormat(this.options.autoFormatSeparator); }
    if (this.options.autoSubmit)
        { this.enableAutoSubmit(this.options.autoSubmitFormId || ""); }
    if (this.options.iFieldstyle)
        { this.setStyle(Object.assign({}, this.options.iFieldstyle)); }
    this.$emit('load');
}
/**
 *
 * @param {{data: TokenData | ErrorData}} param0
 */
function _onToken(ref) {
    var data = ref.data;

    this.tokenLoading = false;
    if (data.result === ERROR) {
        this.latestErrorTime = new Date();
        this.log("Token Error: " + data.errorMessage);
        this.$emit('error', { data: data });
    } else {
        this.xTokenData = data;
        this.$emit('token', { data: data });
    }
}
/**
 *
 * @param {{data: UpdateData}} param0
 */
function _onUpdate(ref) {
    var data = ref.data;

    var shouldGetToken = data.isValid
        && data.length !== this.ifieldDataCache.length
        && !this.tokenLoading
        && this.options.autoSubmit;
    if (shouldGetToken) {
        this.getToken();
    }
    this.ifieldDataCache = {
        length: data.length
    };
    switch (data.event) {
        case 'input':
            this.$emit('input', { data: data });
            break;
        case 'click':
            this.$emit('click', { data: data });
            break;
        case 'focus':
            this.$emit('focus', { data: data });
            break;
        case 'dblclick':
            this.$emit('dblclick', { data: data });
            break;
        case 'change':
            this.$emit('change', { data: data });
            break;
        case 'blur':
            this.$emit('blur', { data: data });
            break;
        case 'keypress':
            this.$emit('keypress', { data: data });
            break;
    }
    this.$emit('update', { data: data });
}

/**
 *
 * @param {{data: SubmitData}} param0
 */
function _onSubmit(ref) {
    var data = ref.data;

    //call first before submit is triggered
    this.$emit('submit', { data: data });
    if (data && data.formId) {
        document.getElementById(data.formId).dispatchEvent(
            new Event("submit", {
                bubbles: true,
                cancelable: true
            })
        );
    }
}


/**
 * @typedef SubmitData
 * @property {string} formId
 */
/**
 *
 * @typedef TokenData
 * @property {string} xToken
 * @property {string} xTokenType
 * @property {string} xCardDataType
 * @property {string} xMaskedData
 * @property {string} xIssuer
 * @property {string} xTokenCreationTime
 * @property {string} xTokenVersion
 */
/**
 * @typedef ErrorData
 * @property {string} result
 * @property {string} errorMessage
 * @property {string} xTokenType
 */
/**
 * @typedef UpdateData
 * @property {string} event
 * @property {string} issuer
 * @property {boolean} ifieldValueChanged
 * @property {boolean} isEmpty
 * @property {boolean} isValid
 * @property {number} length
 * @property {number} cardNumberLength
 */

function ping() {
  var message = {
    action: PING
  };
  this.logAction(PING);
  this.postMessage(message);
}
/**
 *
 * @param {AccountData} data
 */
function setAccount(data) {
  var message = {
    action: SET_ACCOUNT_DATA,
    data: data
  };
  this.logAction(SET_ACCOUNT_DATA);
  this.postMessage(message);
}
function init() {
  var message = {
    action: INIT,
    tokenType: this.type,
    referrer: window.location.toString()
  };
  this.logAction(INIT);
  this.postMessage(message);
}
function getToken() {
  var message = {
    action: GET_TOKEN
  };
  this.logAction(GET_TOKEN);
  this.tokenLoading = true;
  this.postMessage(message);
}

/**
 * 
 * @callback Handle3DSResults
 * @param {string} actionCode
 * @param {string} xCavv
 * @param {string} xEciFlag
 * @param {string} xRefNum
 * @param {string} xAuthenticateStatus
 * @param {string} xSignatureVerification
 * @param {string} error
 * @returns {void}
 */

/**
 *
 * @param {string} environment
 * @param {Handle3DSResults} handle3DSResults
 */
function enable3DS(environment, handle3DSResults) {
  if (handle3DSResults) {
    if (typeof window.ck3DS !== 'undefined') {
      ck3DS.configuration.onVerifyComplete = handle3DSResultsWrapper(handle3DSResults);
      ck3DS.configuration.enableConsoleLogging = this.options.enableLogging;
      if (!ck3DS.initialized)
        { ck3DS.initialize3DS(environment); }
    }
  }
  var message = {
    action: ENABLE3DS,
    data: {
      environment: environment,
      verificationEnabled: !!handle3DSResults
    }
  };
  this.logAction(ENABLE3DS);
  this.postMessage(message);
}

function handle3DSResultsWrapper(handle3DSResults) {
  return function (actionCode, xCavv, xEciFlag, xRefNum, xAuthenticateStatus, xSignatureVerification) {
    handle3DSResults(actionCode, xCavv, xEciFlag, xRefNum, xAuthenticateStatus, xSignatureVerification, ck3DS.error);
  }
}
/**
 *
 */
function disable3DS() {
  var message = {
    action: DISABLE3DS,
    data: {}
  };
  this.logAction(ENABLE3DS);
  this.postMessage(message);
}
/**
 *
 */
function verify3DS(verifyData) {
  if (typeof window.ck3DS !== 'undefined')
    { ck3DS.verifyTrans(verifyData); }
  else
    { this.log('verify3DS called without using enable3DS first to attach a handler!'); }
}
/**
 *
 * @param {string} issuer
 */
function updateIssuer(issuer) {
  var message = {
    action: UPDATE_ISSUER,
    issuer: issuer
  };
  this.logAction(UPDATE_ISSUER);
  this.postMessage(message);
}
/**
 *
 * @param {string} data
 */
function setPlaceholder(data) {
  var message = {
    action: SET_PLACEHOLDER,
    data: data
  };
  this.logAction(SET_PLACEHOLDER);
  this.postMessage(message);
}
/**
 *
 * @param {string} formatChar
 */
function enableAutoFormat(formatChar) {
  var message = {
    action: FORMAT,
    data: {
      formatChar: formatChar
    }
  };
  this.logAction(FORMAT);
  this.postMessage(message);
}
function enableLogging() {
  var message = {
    action: ENABLE_LOGGING
  };
  this.logAction(ENABLE_LOGGING);
  this.postMessage(message);
}
/**
 *
 * @param {string} formId - The ID attribute of the form to trigger submit on
 */
function enableAutoSubmit(formId) {
  var message = {
    action: ENABLE_AUTO_SUBMIT,
    data: {
      formId: formId
    }
  };
  this.logAction(ENABLE_AUTO_SUBMIT);
  this.postMessage(message);
}
function setStyle(data) {
  var message = {
    action: STYLE,
    data: data
  };
  this.logAction(STYLE);
  this.postMessage(message);
}
//----------------------Public Actions
function focusIfield() {
  var message = {
    action: FOCUS
  };
  this.logAction(FOCUS);
  this.postMessage(message);
}
function clearIfield() {
  var message = {
    action: CLEAR_DATA
  };
  this.logAction(CLEAR_DATA);
  this.postMessage(message);
}
/**
 * @typedef AccountData
 * @property {string} xKey
 * @property {string} xSoftwareName
 * @property {string} xSoftwareVersion
 */

/**
 *
 * @param {{action: string, data: *}} data
 */
function postMessage(data) {
    if (!this.iFrameLoaded && data.action !== PING) {
        this.log("Iframe not loaded");
        this.ping();
        return;
    }
    try {
        var target = isAccessible(this.iFrameRef.contentWindow) ? location.origin : IFIELD_ORIGIN;
        this.iFrameRef.contentWindow.postMessage(data, target);
    } catch (error) {
        this.log(error);
    }
}

function isAccessible(otherWindow) {
    try {
        if (!otherWindow.document)
            { return false; }
        return true;
    } catch (e) {
        return false;
    }
}
function validateProps() {
    validateIsDefined(this.account, "account");
    validateIsDefined(this.account.xKey, "xKey");
    validateIsDefined(this.account.xSoftwareName, "xSoftwareName");
    validateIsDefined(this.account.xSoftwareVersion, "xSoftwareVersion");
    validateIsDefined(this.type, "type");
}

function validateIsDefined(value, name) {
    if (!value)
        { throw new Error("Missing " + name); }
}

/**
 *
 * @param {string} message
 */
function log(message) {
    if (this.options.enableLogging) {
        console.log(("IField " + (this.type) + ": " + message));
    }
}
/**
 *
 * @param {string} action
 */
function logAction(action) {
    this.log(("Sending message " + action));
}

/**
 * 
 * @param {AccountData} account
 * @returns {AccountData}
 */
function transformAccountData(account) {
    var xSoftwareName = account.xSoftwareName;
    return Object.assign({}, account, { xSoftwareName: ("(" + PLUGIN_NAME + ") " + xSoftwareName) });
}

var script = {
  data: function () {
    return {
      iFrameLoaded: false,
      ifieldDataCache: {},
      latestErrorTime: null,
      xTokenData: {},
      _tokenValid: false,
      tokenLoading: false,
      IFIELDS_VERSION: Object.freeze(IFIELDS_VERSION),
      IFIELD_ORIGIN: Object.freeze(IFIELD_ORIGIN)
    };
  },
  props: {
    type: String,
    account: {
      type: Object,
      default: function () {
        return {};
      }
    },
    options: {
      type: Object,
      default: function () {
        return {
          autoFormatSeparator: AUTO_FORMAT_DEFAULT_SEPARATOR,
          autoSubmit: true
        };
      }
    },
    threeDS: {
      type: Object,
      default: function () {
        return {};
      }
    },
    issuer: String
  },
  methods: {
    //----------------------Events
    onMessage: _onMessage,
    _onLoad: _onLoad,
    _onToken: _onToken,
    _onUpdate: _onUpdate,
    _onSubmit: _onSubmit,

    //----------------------Actions
    ping: ping,
    setAccount: setAccount,
    init: init,
    getToken: getToken,
    enable3DS: enable3DS,
    disable3DS: disable3DS,
    verify3DS: verify3DS,
    updateIssuer: updateIssuer,
    setPlaceholder: setPlaceholder,
    enableAutoFormat: enableAutoFormat,
    enableLogging: enableLogging,
    enableAutoSubmit: enableAutoSubmit,
    setStyle: setStyle,
    //----------------------Public Actions
    focusIfield: focusIfield,
    clearIfield: clearIfield,

    //----------------------Helper Functions
    postMessage: postMessage,
    validateProps: validateProps,
    log: log,
    logAction: logAction,
    transformAccountData: transformAccountData
  },
  mounted: function () {
    this.validateProps();
    window.addEventListener("message", this.onMessage);
    this.iFrameRef = this.$refs.iFrameRef;
    this.ping();
  },
  destroyed: function () {
    window.removeEventListener("message", this.onMessage);
  },
  watch: {
    account: function (val) {
      var newAccount = this.transformAccountData(val);
      this.setAccount(newAccount);
    },
    threeDS: function (val, oldVal) {
      if (this.type !== CARD_TYPE) { return; }
      if (val.enable3DS) {
        if (!val.environment)
          { return; }
        if (this.iFrameLoaded && (!oldVal.enable3DS || val.environment !== oldVal.environment || val.handle3DSResults !== oldVal.handle3DSResults))
          { this.enable3DS(val.environment, val.handle3DSResults); }
      }
      else if (oldVal.enable3DS) {
        this.disable3DS();
      }
    },
    issuer: function (val) {
      if (this.type === CVV_TYPE) { this.updateIssuer(val); }
    },
    options: function (val, oldVal) {
      if (this.type === CARD_TYPE && val.autoFormat) {
        if (
          val.autoFormat !== oldVal.autoFormat ||
          val.autoFormatSeparator !== oldVal.autoFormatSeparator
        )
          { this.enableAutoFormat(val.autoFormatSeparator); }
      }
      if (val.autoSubmit) {
        if (
          val.autoSubmit !== oldVal.autoSubmit ||
          val.autoSubmitFormId !== oldVal.autoSubmitFormId
        )
          { this.enableAutoSubmit(val.autoSubmitFormId); }
      }
      if (val.enableLogging && !oldVal.enableLogging) { this.enableLogging(); }
      if (val.placeholder !== oldVal.placeholder)
        { this.setPlaceholder(val.placeholder); }
      if (val.iFieldstyle !== oldVal.iFieldstyle)
        { this.setStyle(val.iFieldstyle); }
    }
  },
  computed: {
    tokenValid: {
      cache: false,
      get: function get() {
        return this._tokenValid && this.xTokenData && this.xTokenData.xToken;
      },
      set: function set(value) {
        this._tokenValid = value;
      }
    }
  }
};

var _hoisted_1 = ["src", "title"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("iframe", {
    src: _ctx.IFIELD_ORIGIN + '/ifields/' + _ctx.IFIELDS_VERSION + '/ifield.htm',
    ref: "iFrameRef",
    title: $props.type
  }, null, 8 /* PROPS */, _hoisted_1))
}

script.render = render;
script.__file = "src/ifields/ifields.vue";

// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) { return; }
    install.installed = true;
    Vue.component('vue-cardknox-ifields', script);
}

// Create module definition for Vue.use()
var plugin = {
    install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

export { ACH_TYPE, CARD_TYPE, CVV_TYPE, THREEDS_ENVIRONMENT, script as default, install };
